export default {
  list: {
    columns: [
      { key: 'key', width: 200 },
      { key: 'name', width: 300 },
      { key: 'brandRef', width: 130 },
      { key: 'supplierRef', width: 150 },
      { key: 'centerCost', width: 100 },
      { key: 'storeCost', width: 100 },
      { key: 'price', width: 100 },
      { key: 'salePrice', width: 100 },
      { key: 'staffPrice', width: 100 },
      { key: 'model', width: 130 },
      { key: 'size', width: 80 },
      { key: 'colorCode', width: 80 },
      { key: 'material', width: 100 },
      { key: 'contour', width: 100 },
      { key: 'rimType', width: 100 },
      { key: 'colorRef', width: 100 },
    ],
    query: {
      fixedQuery: {
        type: { $eq: 'A' },
      },
    },
  },
  editor: {
    config: { titleSm: 2, titleMd: 1 },
    groups: [
      {
        name: '商品',
        rows: [
          [{ key: 'key' }],
          [{ key: 'name' }],
          [{ key: 'type' }],
          [{ key: 'brandCode' }, { key: 'brandRef' }],
          [{ key: 'supplierRef' }, { key: 'orderCode' }],
          [{ key: 'unit' }],
          [{ key: 'origin' }],
          [{ key: 'note' }],
          [{ key: 'isContract' }],
          [{ key: 'orderFrom' }],
          [{ key: 'payType' }],
          [{ key: 'spec' }],
          [{ key: 'taxType' }],
          [{ key: 'basicAmount' }],
          [{ key: 'ragicStoreNodeId' }, { key: 'ragicCenterNodeId' }],
        ],
      },
      {
        name: '成本',
        rows: [
          [{ key: 'centerCost' }],
          [{ key: 'storeCost' }],
        ],
      },
      {
        name: '價格',
        rows: [
          [{ key: 'price' }],
          [{ key: 'staffPrice' }],
          [{ key: 'salePrice' }],
        ],
      },
      {
        name: '規格 - A 類',
        rows: [
          [{ key: 'model' }],
          [{ key: 'colorRef' }],
          [{ key: 'colorCode' }],
          [{ key: 'size' }],
          [{ key: 'material' }],
          [{ key: 'contour' }],
          [{ key: 'rimType' }],
          [{ key: 'templeLength' }],
        ],
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/views/ui/productsA.js